import { render, staticRenderFns } from "./PeriodSwitcher.vue?vue&type=template&id=4801fbba&scoped=true&"
import script from "./PeriodSwitcher.vue?vue&type=script&lang=js&"
export * from "./PeriodSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4801fbba",
  null
  
)

export default component.exports